import { Controller } from "@hotwired/stimulus"
import { destroy, post } from "@rails/request.js"

export default class extends Controller {
  static targets = [
    'input'
  ]

  static values = {
    pieceTagPath: String,
    pieceTagsPath: String
  }

  connect() {
    this.inputTarget.addEventListener('keydown', this.submit.bind(this))
  }

  disconnect() {
    this.inputTarget.removeEventListener('keydown', this.submit.bind(this))
  }

  async submit(e) {
    if (e.key === 'Enter') {
      e.preventDefault()

      const response = await post(this.pieceTagsPathValue, {
        body: JSON.stringify({ name: this.inputTarget.value })
      })

      if (response.ok) {
        document.querySelector('turbo-frame#tags').reload()
      }
    }
  }

  async delete(e) {
    const url = this.pieceTagPathValue.replace(':id', e.currentTarget.dataset.id)
    const response = await destroy(url)

    if (response.ok) {
      document.querySelector('turbo-frame#tags').reload()
    }
  }
}
